import * as React from "react";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styles from "src/components/UI/LeftCard/assets/scss/Menu.module.scss";
import { _GetTitle, _GetType } from "src/components/UI/Shared/handler";
import {
  FreeIcon,
  PremiumIcon,
  MixedIcon,
} from "src/components/UI/LeftCard/icons";
import path from "src/config/search.json";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface ControlledOpenSelect5Props {}

const ControlledOpenSelect5 = ({}: ControlledOpenSelect5Props) => {
  const dispatch = useDispatch();
  const searchString = useSelector((state: any) => state.app.searchString);
  let navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(
      appActions.setSearchString({
        ...searchString,
        menu5: event.target.value,
      })
    );
  };

  const handleGoToSearchString = (choosen: string) => {
    if (choosen === "service-area") {
      navigate(`${currentkey}/${path.services.Routing[0].url}`);
    } else if (choosen === "routing") {
      navigate(`${currentkey}/${path.services.Routing[1].url}`);
    }
  };
  React.useEffect(() => {
    handleGoToSearchString(searchString.menu5);
  }, [searchString]);
  const keys = Object.keys(path.services);
  const currentkey = keys[4];
  const Icon = (category: number, item: number) => {
    const type = _GetType(category, item);
    if (type === "free") return <FreeIcon />;
    else if (type === "premium") return <PremiumIcon />;
    return <MixedIcon />;
  };
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120, margin: "0.75rem 0" }}>
        <InputLabel
          id="demo-controlled-open-select-label"
          className={styles.label}
        >
          {currentkey}
        </InputLabel>
        <Select
          className={styles.select}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          value={searchString.menu5}
          onChange={handleChange}
          onClose={handleClose}
          onOpen={handleOpen}
          label="selectValue"
        >
          <MenuItem className={styles.menuItem} value={"service-area"}>
            {_GetTitle(4, 0)}
            {Icon(4, 0)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"routing"}>
            {_GetTitle(4, 1)}
            {Icon(4, 1)}
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default ControlledOpenSelect5;
